import {
  ChatMultipleRegular,
  ShieldTaskRegular,
  PersonKeyRegular,
  LaptopRegular,
  BranchForkRegular,
  DocumentSearchRegular,
  GaugeRegular,
  AppsRegular,
  InfoRegular,
} from '@fluentui/react-icons'
import type { NavigationGroup } from '@/types/navigation'

export const navigationGroups: NavigationGroup[] = [
  {
    id: 'overview',
    title: 'Overview',
    items: [
      {
        id: 'workspace',
        label: 'Investigation Workspace',
        description: 'The main investigation workspace.',
        icon: ChatMultipleRegular,
        isPanel: false,
      },
    ],
  },
  {
    id: 'investigate',
    title: 'Investigate',
    items: [
      {
        id: 'incidents',
        label: 'Incidents',
        description: 'Cross-domain incident investigation and correlation.',
        icon: ShieldTaskRegular,
        isPanel: true,
      },
      {
        id: 'identity',
        label: 'Identity',
        description: 'Identity risk, sign-ins, MFA and Conditional Access context.',
        icon: PersonKeyRegular,
        isPanel: true,
      },
      {
        id: 'endpoints',
        label: 'Endpoints',
        description: 'Defender device posture, alerts and endpoint activity.',
        icon: LaptopRegular,
        isPanel: true,
      },
    ],
  },
  {
    id: 'analysis',
    title: 'Analysis',
    items: [
      {
        id: 'attack-path',
        label: 'Attack Path',
        description: 'Correlate identity, endpoint and incident evidence.',
        icon: BranchForkRegular,
        isPanel: true,
      },
      {
        id: 'evidence',
        label: 'Evidence',
        description: 'Understand observed signals and evidence gaps.',
        icon: DocumentSearchRegular,
        isPanel: true,
      },
      {
        id: 'risk-assessment',
        label: 'Risk Assessment',
        description: 'Separate Microsoft severity from analyst confidence.',
        icon: GaugeRegular,
        isPanel: true,
      },
    ],
  },
  {
    id: 'system',
    title: 'System',
    items: [
      {
        id: 'capabilities',
        label: 'Capabilities',
        description: 'What SOC-Copilot can currently investigate.',
        icon: AppsRegular,
        isPanel: true,
      },
      {
        id: 'about',
        label: 'About',
        description: 'Architecture and current project phase.',
        icon: InfoRegular,
        isPanel: true,
      },
    ],
  },
]

export const allNavigationItems = navigationGroups.flatMap((group) => group.items)
